<div [formGroup]="avvFormGroup"
     fxLayout="row wrap"
     fxLayoutGap="12px grid">

    <mat-checkbox formControlName="accepted">
        {{ 'workflows.formWidgets.avv.acceptPart1' | translate }}<a (click)="openAvvTemplate($event)" style="cursor: pointer; text-decoration: underline;">{{ 'workflows.formWidgets.avv.avvLink' | translate }}</a>{{ 'workflows.formWidgets.avv.acceptPart2' | translate }}
    </mat-checkbox>
    <ng-container *ngIf="avvFormGroup.get('accepted').invalid && avvFormGroup.get('accepted').touched">
        <div>
            <mat-error>{{avvFormGroup.get('accepted').errors | firstErrorMessage}}</mat-error>
        </div>
    </ng-container>

    <div>
        <p>
            {{ 'workflows.formWidgets.avv.signatureIntro' | translate }}
        </p>
    </div>

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.avv.signatureLabel' | translate }}</mat-label>
        <input matInput data-test="FI-Name" type="text" formControlName="signatureText"
               autocomplete="new-password">
        <mat-error>{{avvFormGroup.get('signatureText').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

</div>
